import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['trockener Mund, als hättest du die ganze Nacht in der Wüste gelegen', 'dieser dumpfe Nebel im Kopf', 'und (wenn du ehrlich bist) ein leiser Stress, weil du weißt: Das ist nicht nur nervig. Das kostet Beziehung. Und Energie.'];
  return <section className="w-full bg-[#1e293b] py-20 px-4 md:px-6 border-t border-[#334155]" data-id="element-132">
      <div className="max-w-2xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-[#faf5ef] mb-4 leading-tight" data-id="element-135">
            Das eigentliche Problem ist nicht dein Schnarchen.
          </h2>
          <h3 className="text-xl md:text-2xl text-[#d4a574] font-semibold mb-10" data-id="element-136">
            Das Problem ist, dass du es nicht steuern kannst.
          </h3>

          <div className="space-y-6 text-lg text-[#cbd5e1] leading-relaxed" data-id="element-137">
            <p data-id="element-138">
              Du legst dich hin mit dem Gedanken: "Heute wird's besser." Und
              trotzdem passiert's wieder — irgendwann in der Nacht.
            </p>
            <p data-id="element-139">Und am Morgen ist da:</p>

            <ul className="space-y-4 my-8 pl-4 border-l-2 border-[#d4a574]/30" data-id="element-140">
              {pains.map((pain, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1 + 0.3
            }} className="flex items-start" data-id="element-141">
                  <span className="text-[#cbd5e1]" data-id="element-142">
                    {pain.includes('trockener Mund') ? <>
                        <span className="text-[#d4a574] font-semibold" data-id="element-143">
                          trockener Mund
                        </span>
                        , als hättest du die ganze Nacht in der Wüste gelegen
                      </> : pain.includes('dumpfe Nebel') ? <>
                        dieser{' '}
                        <span className="text-[#d4a574] font-semibold" data-id="element-144">
                          dumpfe Nebel
                        </span>{' '}
                        im Kopf
                      </> : pain}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}